const swiperTestimonial = new Swiper(
  ".testimonial-slides .swiper-testimonial",
  {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-testimonials",
      prevEl: ".swiper-button-prev-testimonials",
    },
    pagination: {
      el: ".swiper-pagination-testimonials",
    },
  }
);

(function () {
  const carousel = swiperTestimonial.el.closest('[aria-roledescription="carousel"]');
  if (!carousel) return;

  const liveRegion = carousel.querySelector(".swiper-wrapper");
  const srToggle = carousel.querySelector(".testimonial-rotation-toggle");
  const visualToggle = carousel.querySelector(".testimonial-rotation-toggle-visual");
  const pauseIcons = carousel.querySelectorAll(".testimonial-rotation-toggle__pause");
  const playIcons = carousel.querySelectorAll(".testimonial-rotation-toggle__play");
  let isRotating = true;

  function updateSlideVisibility() {
    const slides = carousel.querySelectorAll(".swiper-slide");
    slides.forEach(function (slide) {
      const isActive = slide.classList.contains("swiper-slide-active");
      slide.setAttribute("aria-hidden", String(!isActive));
      if (isActive) {
        slide.removeAttribute("inert");
      } else {
        slide.setAttribute("inert", "");
      }
    });
  }

  updateSlideVisibility();
  swiperTestimonial.on("slideChangeTransitionEnd", updateSlideVisibility);

  function stopRotation() {
    if (!isRotating) return;
    isRotating = false;
    swiperTestimonial.autoplay.stop();
    if (liveRegion) liveRegion.setAttribute("aria-live", "polite");
    if (srToggle) srToggle.setAttribute("aria-label", "Start slide rotation");
    pauseIcons.forEach(function (el) { el.classList.add("hidden"); });
    playIcons.forEach(function (el) { el.classList.remove("hidden"); });
  }

  function startRotation() {
    if (isRotating) return;
    isRotating = true;
    swiperTestimonial.autoplay.start();
    if (liveRegion) liveRegion.setAttribute("aria-live", "off");
    if (srToggle) srToggle.setAttribute("aria-label", "Stop slide rotation");
    pauseIcons.forEach(function (el) { el.classList.remove("hidden"); });
    playIcons.forEach(function (el) { el.classList.add("hidden"); });
  }

  function handleToggle() {
    if (isRotating) {
      stopRotation();
    } else {
      startRotation();
    }
  }

  // Both buttons trigger the same toggle
  if (srToggle) srToggle.addEventListener("click", handleToggle);
  if (visualToggle) visualToggle.addEventListener("click", handleToggle);

  // Stop rotation when keyboard focus enters the carousel (but not from toggle buttons)
  carousel.addEventListener("focusin", function (e) {
    if (e.target.closest(".testimonial-rotation-toggle, .testimonial-rotation-toggle-visual")) return;
    stopRotation();
  });

  // Update aria-live when Swiper pauses/resumes on hover (handled by pauseOnMouseEnter)
  swiperTestimonial.on("autoplayStop", function () {
    if (liveRegion) liveRegion.setAttribute("aria-live", "polite");
  });

  swiperTestimonial.on("autoplayStart", function () {
    if (isRotating && liveRegion) liveRegion.setAttribute("aria-live", "off");
  });
})();
